import Product from './Product';
import { openModal } from '../../helpers/modals';
import showQuickshop from '../../helpers/showQuickshop';

const selectors = {
  quickShopTrigger: '[data-quickshop-trigger]',
  modalProduct: '[data-product]',
  modalContent: 'quickshop-content',
};

const MODAL_ID = 'quickshop';

/**
 * A single product item in a collection / list of products
 *
 * @export
 * @class ProductItem
 */
export default class ProductItem {
  /**
   * Creates an instance of ProductItem.
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;

    this._initQuickShop();
  }

  _initModal(data, quickShopUrl) {
    const quickshopHtml = showQuickshop(data);
    const quickShopContent = document.getElementById(selectors.modalContent);
    quickShopContent.innerHTML = quickshopHtml;

    openModal(MODAL_ID);

    const product = quickShopContent.querySelector(selectors.modalProduct);

    // Create a new Product instance for the requested quickshop product
    new Product(product, {
      isQuickShop: true,
      quickShopUrl,
      modalId: MODAL_ID,
    });
  }

  /**
   * Bind quickshop to a trigger
   */
  _initQuickShop() {
    const trigger = this.el.querySelector(selectors.quickShopTrigger);

    if (!trigger) {
      return;
    }

    trigger.addEventListener('click', () => {
      const { productUrl } = this.el.dataset;

      const quickShopUrl = `${productUrl}?section_id=${window.quickshopSectionId}`;

      fetch(quickShopUrl)
        .then(response => response.text())
        .then(data => {
          this._initModal(data, quickShopUrl);
        });
    });
  }
}
